'use client'

import Toast from '@/components/ui/Toast'
import { useToastStore } from '@/stores/toast-store'

const Toasts = () => {
  const toasts = useToastStore((state) => state.toasts)
  const hideToast = useToastStore((state) => state.hideToast)

  return (
    <>
      {toasts.map((toast, index) => (
        <Toast
          key={toast.id}
          open
          message={toast.message}
          variant={toast.variant}
          durationMs={toast.durationMs}
          onClose={() => hideToast(toast.id)}
          style={{ top: `${5 + index * 4.25}rem` }}
        />
      ))}
    </>
  )
}

export default Toasts
